var _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.664,0H130.336C109.8,0,93.091,16.7,93.091,37.218v353.764v93.009c0,15.446,12.536,28.009,27.945,28.009h269.927 c15.409,0,27.945-12.564,27.945-28.009v-93.009V37.218C418.909,16.7,402.2,0,381.664,0z M400.291,483.991 c0,5.182-4.182,9.391-9.327,9.391H121.036c-5.145,0-9.327-4.209-9.327-9.391v-83.7h288.582V483.991z M400.291,381.673H111.709 V37.218c0-10.255,8.354-18.6,18.627-18.6h251.327c10.273,0,18.627,8.345,18.627,18.6V381.673z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.655,418.909c-15.4,0-27.927,12.527-27.927,27.927s12.527,27.927,27.927,27.927s27.927-12.527,27.927-27.927 S276.055,418.909,260.655,418.909z M260.655,456.145c-5.136,0-9.309-4.173-9.309-9.309s4.173-9.309,9.309-9.309 s9.309,4.173,9.309,9.309S265.791,456.145,260.655,456.145z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.655,288.582c-30.8,0-55.855,25.054-55.855,55.854c0,5.145,4.164,9.309,9.309,9.309H307.2 c5.145,0,9.309-4.164,9.309-9.309C316.509,313.636,291.455,288.582,260.655,288.582z M224.6,335.127 c4.136-16.045,18.736-27.927,36.055-27.927s31.918,11.882,36.055,27.927H224.6z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.cbf6039501086d57a6bff5ed3bca3fa3.svg";
export { ForwardRef as ReactComponent };